import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { applyExternalLinkBehavior } from '@nech/src/helpers/external-links';

(function (Drupal, $) {
  drupalComponent('alert', {
    selector: '[role="alert"]',

    attach(context) {
      const $elements = $(this.selector, context);

      $elements.each(function () {
        const $alert = $(this);

        if ($alert.data('alert-links-attached')) {
          return;
        }

        applyExternalLinkBehavior($alert);

        $alert.data('alert-links-attached', true);
      });
    },
  });
})(Drupal, jQuery);
